module.exports = __webpack_public_path__ + "0b551cc815dbeda898c705b9811210dc.svg";